/*
 * iForte's mural artwork ("asset marcom"), vectorised from the organiser's PNGs
 * to SVG (colour trace, then SVGO). Imported as URLs so each loads only on the
 * page that shows it; every use is decorative (alt="", aria-hidden).
 */
import bujangGanong from "./icons/bujang-ganong.svg";
import bungaKuning from "./icons/bunga-kuning.svg";
import bungaKuning2 from "./icons/bunga-kuning-2.svg";
import bungaUngu from "./icons/bunga-ungu.svg";
import burung from "./icons/burung.svg";
import flowerHead from "./icons/flower-head.svg";
import jam from "./icons/jam.svg";
import leak from "./icons/leak.svg";
import lidahMertua from "./icons/lidah-mertua.svg";
import parabola from "./icons/parabola.svg";
import planet from "./icons/planet.svg";
import rafflesia from "./icons/rafflesia.svg";
import rumputLaut from "./icons/rumput-laut.svg";
import rumputOrange from "./icons/rumput-orange.svg";
import satelit from "./icons/satelit.svg";
import tembak from "./icons/tembak.svg";
import tower from "./icons/tower.svg";
import ufo from "./icons/ufo.svg";
import band from "./templates/template-2.svg";
import wall from "./templates/template-3.svg";

export const MURAL = {
  bujangGanong,
  bungaKuning,
  bungaKuning2,
  bungaUngu,
  burung,
  flowerHead,
  jam,
  leak,
  lidahMertua,
  parabola,
  planet,
  rafflesia,
  rumputLaut,
  rumputOrange,
  satelit,
  tembak,
  tower,
  ufo,
} as const;

export type MuralIcon = keyof typeof MURAL;

/** Template 2: a wide band of the mural with an open sky above it. */
export const MURAL_BAND = band;
/** Template 3: the full wall, edge to edge. */
export const MURAL_WALL = wall;
